import Challenge from "./pages/challenge";

function App() {
  return (
    <div className="App">
      <Challenge />
    </div>
  );
}

export default App;
